import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { AffiliationsOverview } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class AffiliationsOverviewModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
  }

  render() {
    const { modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title='Affiliations'
        titleKey='moduleTitle.affiliations_overview'
        wider
      >
        <MaterialModal.Content>
          <AffiliationsOverview {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
